import track from '@/utils/segment'
import identifyPage from '@/utils/identifyPage'
import isPaidUser from '@/utils/isPaidUser'
import isPlayer from '@/utils/isPlayer'
import isExpiredUser from '@/utils/isExpiredUser'
import isIdentityVerified from '@/utils/isIdentityVerified'

export default name => {
    if (isPlayer()) {
        const eventName =
            isExpiredUser() ? 'expired_cta' :
            isIdentityVerified() ? 'upgrade_account_cta' :
            isPaidUser() ? 'get_verified_cta_paid_user' :
            'get_verified_cta'

        track(eventName, {
            cta_page: identifyPage(window.location.href),
            cta_name: name,
        })
    }
}